/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['Collection', 'Currency'];

const factory = function (Collection, Currency) {
  let CurrencyCollection;
  return (CurrencyCollection = (function () {
    CurrencyCollection = class CurrencyCollection extends Collection {
      static initClass() {
        this.prototype.$resource = 'currency';

        this.prototype.$id = 'single';

        this.prototype.$type = Currency;
      }

      $init() {
        super.$init();
        return this.$fetch();
      }
    };
    CurrencyCollection.initClass();
    return CurrencyCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/model/currency').name];

module.exports = angular
  .module('bench.data.collection.currency', moduleDeps)
  .factory('CurrencyCollection', factory);
